import { Flex, Text, Divider, Title } from "@mantine/core";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import UpdateChecker from "src/components/shared/UpdateChecker";
import { getOrigin } from "src/environment";
import { PageContainer } from "src/styled";

import { CardContainer, SystemImage } from "./DesktopApp.styled";

const disabledAppStores = false;

const DesktopApp = () => {
  return (
    <PageContainer>
      <Breadcrumbs />
      <Flex p="xl" direction="column" wrap="wrap" align="center" gap="xl">
        {window?.api && (
          <>
            <Title order={2}>Desktop App Updates</Title>
            <UpdateChecker />
            <Divider my="xl" style={{ width: "100%", maxWidth: "600px" }} />
          </>
        )}

        {!window?.api && (
          <>
            <Title order={2}>Download Desktop App</Title>
            <Flex gap="xl" wrap="wrap" justify="center">
              <CardContainer
                href={getOrigin() + "/api/v1/apps/DeskApp/eLogbooks-mac.dmg"}>
                <SystemImage height={"110px"} src="/assets/Apple.svg"></SystemImage>
                <Text mt={40}>Download Mac OS</Text>
                <Text>(Desktop)</Text>
              </CardContainer>
              <CardContainer
                href={getOrigin() + "/api/v1/apps/DeskApp/eLogbooks-win.exe"}>
                <SystemImage height={"110px"} src="/assets/Windows.svg"></SystemImage>
                <Text mt={40}>Download Windows</Text>
                <Text>(Desktop)</Text>
              </CardContainer>
            </Flex>
            <Divider my="xl" style={{ width: "100%", maxWidth: "600px" }} />
          </>
        )}

        <Title order={2}>Mobile & Tablet Apps</Title>
        <Flex gap="xl" wrap="wrap" justify="center">
          <CardContainer
            disabled={disabledAppStores}
            href="https://apps.apple.com/gb/app/elogbooks/id6479199806">
            <SystemImage height={"110px"} src="assets/app-store.svg"></SystemImage>
            <Text mt={40}>Download App Store</Text>
            <Text>(Tablet)</Text>
          </CardContainer>
          <CardContainer
            disabled={disabledAppStores}
            href="https://play.google.com/store/apps/details?id=com.ljelogbooks.eLogbooks">
            <SystemImage height={"110px"} src="assets/google-play.svg"></SystemImage>
            <Text mt={40}>Download Google Play</Text>
            <Text>(Tablet)</Text>
          </CardContainer>
          <CardContainer
            disabled={disabledAppStores}
            href="https://www.amazon.co.uk/dp/B0CXKBG6P8">
            <SystemImage height={"110px"} src="assets/Amazon_icon.svg"></SystemImage>
            <Text mt={40}>Download Amazon</Text>
            <Text>(Tablet)</Text>
          </CardContainer>
        </Flex>
      </Flex>
    </PageContainer>
  );
};

export default DesktopApp;
